<mat-card appearance="outlined">
    <mat-card-header>
        <mat-icon class="card-header-icon" mat-card-avatar>monitor</mat-icon>
        <mat-card-title>Environment</mat-card-title>
        <mat-card-subtitle>Configure Environment for Engine and Application</mat-card-subtitle>
    </mat-card-header>
    <mat-card-actions>
    </mat-card-actions>
    <mat-card-content>
        <mat-expansion-panel>
            <mat-expansion-panel-header style="color: orange">Transform Engine Endpoint <span style="margin-left: 5px; color: #1ea9d3"> ({{selectedEngineEndpoint.name}})</span></mat-expansion-panel-header>
            <mat-list>
                <mat-list-item [ngClass]="{selectedItemPanel: selectedEngineEndpoint === item}" *ngFor="let item of environmentService.engineEndpoints" (click)="onEngineEndpointSelected(item)"
                    style="cursor: pointer">
                    <span style="width: 100px; display: inline-block;"
                        [ngClass]="{selectedItem: selectedEngineEndpoint === item}">{{item.name}}</span>
                    <span style="color: gray;">{{item.url}}</span>
                    <mat-icon style="margin-left: 32px;" *ngIf="selectedEngineEndpoint === item"
                        [ngClass]="{selectedItemIcon: selectedEngineEndpoint === item}">monitor</mat-icon>
                </mat-list-item>
            </mat-list>
        </mat-expansion-panel>
        <br>
        <mat-expansion-panel>
            <mat-expansion-panel-header style="color: orange">Application Endpoint <span style="margin-left: 5px; color: #1ea9d3"> ({{selectedAppEndpoint.name}})</span></mat-expansion-panel-header>
            <mat-list>
                <mat-list-item [ngClass]="{selectedItemPanel: selectedAppEndpoint === item}"  *ngFor="let item of environmentService.appEndpoints" (click)="onAppEndpointSelected(item)"
                    style="cursor: pointer">
                    <span style="width: 100px; display: inline-block;"
                        [ngClass]="{selectedItem: selectedAppEndpoint === item}">{{item.name}}</span>
                    <span style="color: gray;">{{item.url}}</span>
                    <mat-icon style="margin-left: 32px;" *ngIf="selectedAppEndpoint === item"
                        [ngClass]="{selectedItemIcon: selectedAppEndpoint === item}">monitor</mat-icon>
                </mat-list-item>
            </mat-list>
        </mat-expansion-panel>
    </mat-card-content>
</mat-card>